import { prop, sortBy } from 'rambda';

import type { ShortArticle } from '../components/ArticleList';

export const sortByName = sortBy(prop('name'));

// Titles are numbered like "2. Käyttöliittymä" and "17.7. Asetukset ja mallit",
// so digits have to compare as numbers. A plain string compare puts "10." before "2.".
const compareTitles = (a: string, b: string, locale?: string) => a.localeCompare(b, locale, { numeric: true });

export const sortByTitleWeighted = (articles: ShortArticle[], locale?: string): ShortArticle[] => {
  return [...articles].sort((a, b) => {
    if (a.weight === b.weight) {
      return compareTitles(a.title, b.title, locale);
    }

    return b.weight - a.weight;
  });
};
